// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "98769c2ef9db522a097b20e3286d57fd" + ".js";
};